import services from '../config/pageData.config';

import { Route } from 'vue-router';
import { Store } from 'vuex';
import { Config } from '../../../modules/channel/types/channel';

type Sentry = typeof import('@sentry/minimal/dist/index');
type RouteNames = keyof typeof services;

type FetchChannelConfigOptions = {
  req: PortalRootIncomingMessage;
  route: Route;
  store: Store<any>;
  $sentry: Sentry;
  channelConfig: Config;
};

const fetchPageData = async (options: FetchChannelConfigOptions) => {
  const { route, store, $sentry, channelConfig, req } = options;

  // Fetch page data
  try {
    // List all variables that might be used in a service
    const possibleVariables = {
      channelId: channelConfig.settings.externalId,
      channel: channelConfig.settings.id,
      domain: channelConfig.settings.domain,
      language: channelConfig.settings.lang.toUpperCase(),
      id: route.params.issueid || route.params.id,
      parent: route.params.parent as string,
      slug: route.params.slug as string,
      page: route.query.page as string,
      preview: route.query.preview as string,
      application: channelConfig.settings.application,
      tagLanguage: channelConfig.settings.lang.toUpperCase(),
    };

    const routeName = route.name as RouteNames;
    // If path is found in services object then try to fetch active paths data
    if (routeName && routeName in services && process.server) {
      const handler = {
        variables: services[routeName].variables,
        service: services[routeName].service,
        store: services[routeName]?.store || routeName,
      };

      const variables: typeof possibleVariables | Record<string, unknown> = {};
      // Find correct variables for the active service
      handler.variables.forEach((variable: keyof typeof possibleVariables) => {
        variables[variable] = possibleVariables[variable];
      });

      const data = await handler.service(variables as typeof possibleVariables, { req, channelConfig });
      // Saved service data to active page store
      store.commit(`${handler.store}/setTempData`, data);
    }
  } catch (e) {
    $sentry.captureException(`fetchPageData - ${e.message} - externalId: ${route.params.id}, routeName: ${route.name}`, {
      tags: { 'process.type': process.server ? 'server' : 'client' },
    });
  }
};

export default fetchPageData;
